module.exports = __webpack_public_path__ + "img/顶部背景@2x.ea29aeb4.png";